export class BookingOrderProcessStage {
  name: string;
  desc: string;
  canDownloadDeclarationInfo: boolean;
  canDownloadShippingOrderInfo: boolean;
  canUploadInvoice: boolean;
  canCheckInvoice: boolean;
  canDownloadInvoiceA: boolean;
  canDownloadInvoiceB: boolean;
  canReUploadInvoice: boolean;
  canDownloadInvoiceTemplate: boolean;
  canConfirmDeclarationInfo: boolean;
  canSeeDeclarationInfo: boolean;
  canDeleteBookingOrder: boolean;
  canAudit: boolean;
  canQueryAuditInfo: boolean;
}

export class DeclarationState {

  name: string;
  desc: string;
  canEditSailingDate: boolean;
  canEditDeadlineDateDate: boolean;
  canEditDeclarationState: boolean;
  canConfirmReceipt: boolean;
  canDeclared: boolean;
}


export class Company {
  id: string;
  name: string;
  type: CompanyType;
  invoiceCode: string;
  paymentDate: string;
  charges: ForwardingCharge[];
}

export class CompanyType {
  name: string;
  desc: string;

  constructor(name: string, desc: string) {
    this.name = name;
    this.desc = desc;
  }
}

export class ForwardingCharge {
  type: string;
  charge: number;
}

export class ForwardingChargeType {
  name: string;
  desc: string;
}
